import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'nameComposition'
})
export class NameCompositionPipe implements PipeTransform {
  transform(val: string, ...args: string[]): string {
    if (!args.length) {
      return val;
    }
    return args.reduce(
      (acc, el, index) => (index === args.length ? acc + el : acc + ' ' + el),
      val
    );
  }
}
